import { IRuleFilter } from '@cbridge-tools/rules-data-grid-filter';
import { RuleStatus, RuleValidity } from '@cbridge-tools/rules-data-grid';
import { IRuleManagementRowModel } from '@cbridge-packages/rule';
import { IAdjustmentRuleRowModel } from '@cbridge-packages/adjustment-rules';
import { IOrderLifetimeRuleRowModel } from '@cbridge-packages/order-lifetime-rules';
import { IPriceFilteringRuleRowModel } from '@cbridge-packages/price-filtering-rules';
import { IPricingRuleRowModel } from '@cbridge-packages/pricing-rules';
import { IRoutingRuleRowModel } from '@cbridge-packages/routing-rules';

export enum FilterMode {
  Strict = 'strict',
  Relaxed = 'relaxed',
}

export interface IRulesManagementState {
  errorsCount?: number;
  unusedCount?: number;
  uselessCount?: number;
  filterByStatus?: IRuleFilter<RuleStatus>;
  rules?: IPermittedRuleRowModel[];
  invalidRules?: Set<number>;
}

export type RowsComparator<R extends IRuleManagementRowModel = IRuleManagementRowModel> = (row: R) => boolean;

export interface IRulesFilter {
  status?: IRuleFilter<RuleStatus>;
  validity?: IRuleFilter<RuleValidity>;
}

export type IPermittedRuleRowModel =
  IAdjustmentRuleRowModel
  | IOrderLifetimeRuleRowModel
  | IPriceFilteringRuleRowModel
  | IPricingRuleRowModel
  | IRoutingRuleRowModel;

export interface IRulesManagementStore {
  count: number;
  filteredCount?: number;
  filter: IRulesFilter;
  filterMode: FilterMode;
  editMode: boolean;
  rules?: IPermittedRuleRowModel[];
  // Set of IDs of invalid rules
  invalidRules: Set<number>;
  isSidebarOpen: boolean;
  /** Page prefix of the persisted settings (`{settingsKey}.sidebar.open`), set by the page at mount. */
  settingsKey?: string;
}

export interface IRulesManagementStoreSegment {
  rulesManagement: IRulesManagementStore;
}
